import { render, staticRenderFns } from "./CategoryIndex.vue?vue&type=template&id=f556790e&scoped=true"
import script from "./CategoryIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryIndex.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CategoryIndex.vue?vue&type=style&index=0&id=f556790e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f556790e",
  null
  
)

export default component.exports